export default "__VITE_ASSET__Dyd3dnQJ__"